import React from 'react';
import { Form, Button, Typography, Tooltip } from '@douyinfe/semi-ui';
import { IconUserCircleStroked, IconLockStroked, IconSmartphoneStroked, IconHorn, IconHelpCircleStroked } from '@douyinfe/semi-icons';
import { isEmpty, isNull } from "lodash";

//import controller;
import { createAdmin, checkAdmin } from "../../../controllers/initController";

class InitAdmin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: null,
            password: null,
            username_onec: null,
            password_onec: null,
            telegram: null,
            phone: null,
            message: null,
            done: null
        };
        this.handleCreateAdmin = this.handleCreateAdmin.bind(this);
        this.checkAdmin = this.checkAdmin.bind(this);
    }

    checkAdmin = async() => {

        const toaster = this.props.toaster;

        try {
            let check = await checkAdmin();
            if (!isEmpty(check.data) || !isNull(check.data)) {
                this.setState({ done: true, message: check.message });
                this.props.check(false);
            } else {
                this.setState({ done: false, message: null });
                this.props.check(true);
            }
        } catch (e) {
            toaster.error({ content: e.response?.data?.message || 'Ошибка проверки существования администратора' });
        }
    }

    handleCreateAdmin = async() => {

        const toaster = this.props.toaster;

        let fields = {
            user_name: this.state.username,
            user_password: this.state.password,
            user_infobase_login: this.state.username_onec,
            user_infobase_password: this.state.password_onec,
            telegram: this.state.telegram,
            phone: this.state.phone
        };

        if(isEmpty(this.state.username) || isNull(this.state.username)) return toaster.error({ content: 'Укажите имя администратора!' });
        if(isEmpty(this.state.password) || isNull(this.state.password)) return toaster.error({ content: 'Укажите пароль администратора!' });
        if(isEmpty(this.state.username_onec) || isNull(this.state.username_onec)) return toaster.error({ content: 'Укажите имя пользователя 1С!' });
        if(isEmpty(this.state.password_onec) || isNull(this.state.password_onec)) return toaster.error({ content: 'Укажите пароль пользователя 1С!' });
        if(isEmpty(this.state.phone) || isNull(this.state.phone)) return toaster.error({ content: 'Укажите номер телефона администратора!' });
        if(isEmpty(this.state.telegram) || isNull(this.state.telegram)) return toaster.error({ content: 'Укажите telegram (username) администратора!' });

        try {
            let request = await createAdmin(fields);
            if (!isEmpty(request)) {
                toaster.success({ content: request.message });
                this.setState({ done: true, message: request.message });
                this.props.check(false);
            }
        } catch (e) {
            toaster.error({ content: e.response?.data?.message || 'Ошибка создания администратора' });
        }
    }

    componentDidMount() {
        this.props.check(true);
        this.checkAdmin();
    }

    render() {
        const { Text } = Typography;
        let done = this.state.done;

        return (
            <Form layout="vertical" key="admin-form">
                {done ? (
                    <div className='modal-fixed-custom' style={{ textAlign: 'center' }} key="done-state">
                        <Text style={{ color: 'green', fontSize: 48, paddingBottom: 15 }}>✓</Text>
                        <Text>{this.state.message}</Text>
                    </div>
                ) : (
                    <div className='modal-fixed-custom' key="form-content">
                        <Form.Input
                            field="username"
                            label={{
                                text: 'Пользователь (только латинские буквы)',
                                extra: <Tooltip content="Введите имя пользователя с использованием только латинских букв"><IconHelpCircleStroked style={{ color: 'var(--semi-color-text-2)' }} /></Tooltip>
                            }}
                            prefix={<IconUserCircleStroked />}
                            onChange={(value) => this.setState({ username: value })}
                        />
                        <Form.Input
                            field="password"
                            label={{
                                text: 'Пароль (латинские буквы, цифры, специальные символы)',
                                extra: <Tooltip content="Введите надежный пароль"><IconHelpCircleStroked style={{ color: 'var(--semi-color-text-2)' }} /></Tooltip>
                            }}
                            prefix={<IconLockStroked />}
                            type="password"
                            onChange={(value) => this.setState({ password: value })}
                        />
                        <Form.Input
                            field="username_onec"
                            label={{
                                text: 'Пользователь 1С',
                                extra: <Tooltip content="Введите имя пользователя для 1С"><IconHelpCircleStroked style={{ color: 'var(--semi-color-text-2)' }} /></Tooltip>
                            }}
                            prefix={<IconUserCircleStroked />}
                            onChange={(value) => this.setState({ username_onec: value })}
                        />
                        <Form.Input
                            field="password_onec"
                            label={{
                                text: 'Пароль пользователя 1С',
                                extra: <Tooltip content="Введите пароль для 1С"><IconHelpCircleStroked style={{ color: 'var(--semi-color-text-2)' }} /></Tooltip>
                            }}
                            prefix={<IconLockStroked />}
                            type="password"
                            onChange={(value) => this.setState({ password_onec: value })}
                        />
                        <Form.Input
                            field="telegram"
                            label={{
                                text: 'Telegram (имя пользователя)*',
                                extra: <Tooltip content="Введите имя пользователя Telegram"><IconHelpCircleStroked style={{ color: 'var(--semi-color-text-2)' }} /></Tooltip>
                            }}
                            prefix={<IconHorn />}
                            onChange={(value) => this.setState({ telegram: value })}
                        />
                        <Form.Input
                            field="phone"
                            label={{
                                text: 'Номер телефона',
                                extra: <Tooltip content="Введите номер телефона в формате +7XXX..."><IconHelpCircleStroked style={{ color: 'var(--semi-color-text-2)' }} /></Tooltip>
                            }}
                            prefix={<IconSmartphoneStroked />}
                            onChange={(value) => this.setState({ phone: value })}
                        />
                        <Button icon={<IconUserCircleStroked />} key="submit-button" onClick={this.handleCreateAdmin}>Создать</Button>
                    </div>
                )}
            </Form>
        );
    }
}

export default InitAdmin;